/* eslint-disable eqeqeq */
import request from '../utils/request';
import { routerRedux } from 'dva/router';
import Config,{MethodType} from '../config'

let index = {
    namespace:'index',
    state:{
        nickname :'',
        headimgurl : '',
        coeds:'ERROR',
        grid:[],
        url:[],
        notice:'',
        message : null
    },
    effects:{
      *login({payload},{call,put}){
        let res =yield call(request('xlc/Login',{
            method: MethodType.POST,
            params:{appid:Config.appid,
                    data:{...payload}
            }
        }));
        if(res.data.codes=="NOERROR")
        {
            localStorage.setItem("AAA201",res.data.AAA201);
            localStorage.setItem("AAA001",res.data.AAA001);
            localStorage.setItem("AAA004",res.data.AAA004);
            localStorage.setItem("AAC002",res.data.AAC002);
            localStorage.setItem("AAC003",res.data.AAC003);
            localStorage.setItem("nickname",res.data.nickname);
            localStorage.setItem("headimgurl",res.data.headimgurl);
            yield put({type:'update',payload:{message:res.data.message,coeds:res.data.codes}});

        }else{
            yield put({type:'update',payload:{message:res.data.message,coeds:res.data.codes}});
        }
      },
      *changeRouter({payload},{call,put}){

        yield put(routerRedux.push(payload.route))
       },
       *ChangePassWord({payload},{call,put}){
            let res = yield call(request('xlc/basic/ChangePassWord',{
                method:MethodType.POST,
                params:{appid:Config.appid,
                    data:{...payload}
                }
            }));
           
            yield put({type:'update',payload:{message:res.data.message,coeds:res.data.codes}});
       },
       *Grid_module({payload},{call,put}){
        let res = yield call(request('xlc/home/Grid_module',{
            method:MethodType.GET,
            params:{appid:Config.appid,
            ...payload
            }
        }));
        yield put({type:'update',payload:{grid:res.data}});
       },
       *Ghs_poster({payload},{call,put}){
        let res = yield call(request('xlc/home/Ghs_poster',{
            method:MethodType.GET,
            params:{appid:Config.appid,
                ...payload
            }
        }));
        yield put({type:'update',payload:{url:res.data}});
       },
       *Ghs_notice({payload},{call,put}){
        let res = yield call(request('xlc/home/Ghs_notice',{
            method:MethodType.GET,
            params:{appid:Config.appid,
                ...payload
            }
        }));
        yield put({type:'update',payload:{notice:res.data.notice}});
       },

       *removeBind({payload},{call,put}){
        let res =  yield call(request('xlc/basic/BindPhone',{
                        method:MethodType.PATCH,
                        params:{appid:Config.appid,
                          data:{...payload}
                        }
                    }));
        localStorage.clear();
        
        yield put({type:'update',payload:{message:res.data.message}});
       },
       *aa03queryGHS({payload},{call,put}){
        let res =  yield call(request('xlc/aa/Aa03/aa03queryGHS',{
            method:MethodType.GET,
            params:{appid:Config.appid,
              data:{...payload}
            }
        }));
        return res.data;
       },
       //获取用户手机号和邮箱
       *aa02QueryByAAA201({payload},{call,put}){
        let res =  yield call(request('xlc/aa/Aa02/aa02QueryByAAA201',{
            method:MethodType.GET,
            params:{appid:Config.appid,
              data:{...payload}
            }
        }));
        return res.data;
       },
       //保存基础信息
       *aa02XgJcxx({payload},{call,put}){
        let res =  yield call(request('xlc/aa/Aa02/aa02XgJcxx',{
            method:MethodType.POST,
            params:{appid:Config.appid,
              data:{...payload}
            }
        }));
        console.log(res);
        return res.data;
       },
       *aa02zhma({payload},{call,put}){
        let res =  yield call(request('xlc/aa/Aa02/aa02zhma',{
            method:MethodType.POST,
            params:{appid:Config.appid,
              data:{...payload}
            }
        }));
        console.log(res);
        return res.data;
       },
       *qhdls({payload},{call,put}){

            localStorage.setItem("AAA201",payload.AAA201);
            localStorage.setItem("AAA001",payload.AAA001);
            localStorage.setItem("AAA004",payload.AAA004);
            localStorage.setItem("AAC002",payload.AAC002);
            localStorage.setItem("AAC003",payload.AAC003);
        yield put(routerRedux.push(payload.route))
       }


    },
    reducers:{
        update(state, { payload }) {
            return {
                ...payload
            }
        }   
    }
};
export default index;